// Login

import { simpleFetch, setLang } from "./acCommon"
import { history } from '../history'
import { BookingFlowStep, bookingFlowValidateStepAvailabilities } from "./acBookingFlow";
import moment from "moment";

export const SIGNIN_DATACHANGE = 'SIGNIN_DATACHANGE'
export const signInDataChange = changes => ({type: SIGNIN_DATACHANGE, changes})

export const SIGNIN_METACHANGE = 'SIGNIN_METACHANGE'
export const signInMetaChange = changes => ({type: SIGNIN_METACHANGE, changes})

export const processDataChange = changes => (dispatch, getState) => {
    dispatch(signInDataChange(changes))
    let { email, password } = getState().dataReducer.signin
    if (email !== '' && password !== '') {
        dispatch(signInMetaChange({ canSubmit: true }))
    }
    else {
        dispatch(signInMetaChange({ canSubmit: false }))
    }
}

export const SIGNIN = 'SIGNIN'
export const SIGNIN_REQUEST = 'SIGNIN_REQUEST'
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE'

export const sign_in = () => (dispatch, getState) => {
    let { email, password, remember_me } = getState().dataReducer.signin
	dispatch(sign_in_call(email, password, remember_me))
}

export const sign_in_call = (email, password, remember_me = false) =>  (dispatch, getState) => {
	let body = JSON.stringify({
		email: email,
		password: password
	})

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_sign_in',
	}

	dispatch(simpleFetch('/customers/sign_in/', {
		method: 'POST',
		body: body
	}, SIGNIN, requestMeta)).then(({ actionType, response, requestMeta }) => {
		if (actionType === SIGNIN_SUCCESS) {
			dispatch(setLang(response.data.attributes.default_language))
			if (!remember_me) {
				localStorage.setItem("pootsy-token-expiration-date", moment().add(6, 'hour'))
			}
			localStorage.setItem("pootsy-token", getState().metadataReducer.auth.token)
			if (getState().metadataReducer.bookingFlow.currentStep === BookingFlowStep.WELCOME) {
				history.push('/app')
			}
			else {
				dispatch(bookingFlowValidateStepAvailabilities())
			}
		}
	})
}

export const TOKEN_CHECKED = 'TOKEN_CHECKED'
export const tokenChecked = () => ({ type: TOKEN_CHECKED })

export const CHECKTOKEN_REQUEST = 'CHECKTOKEN_REQUEST'
export const CHECKTOKEN_SUCCESS = 'CHECKTOKEN_SUCCESS'
export const CHECKTOKEN_FAILURE = 'CHECKTOKEN_FAILURE'
export const requireAuth = () => (dispatch, getState) => {
	if (!getState().metadataReducer.auth.signedIn){
		let storedToken = localStorage.getItem('pootsy-token')
		let expirationDate = localStorage.getItem("pootsy-token-expiration-date")

		let tokenExpired = false

		if (expirationDate !== null) {
			tokenExpired = moment(expirationDate) < moment()
		}

		if(tokenExpired){
			localStorage.removeItem('pootsy-token')
			localStorage.removeItem('pootsy-token-expiration-date')
		}

		if (storedToken !== null && expirationDate !== null && !tokenExpired) {
			dispatch(simpleFetch('/customers/token', { method: 'GET' }, 'CHECKTOKEN', { token: storedToken }))
				.then(({ actionType, response }) => {
					if(actionType === CHECKTOKEN_SUCCESS){
						dispatch(setLang(response.data.attributes.default_language))
					}
					dispatch(tokenChecked())
				})
			return
		} else {
			dispatch(tokenChecked())
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/acLogin.js